// icons.js
import React, { useEffect, useState } from "react";
import * as FaIcons from "react-icons/fa";

export default function IconsGallery() {
  const [iconNames, setIconNames] = useState([]);
  const [dripiconNames, setDripiconNames] = useState([]);
  const [faNames, setFaNames] = useState([]);
  const [filter, setFilter] = useState("");
  const [faReactNames, setFaReactNames] = useState([]);

  useEffect(() => {
    const mdiRules = [];
    const dripRules = [];
    const faRules = [];
    for (const sheet of document.styleSheets) {
      try {
        for (const rule of sheet.cssRules) {
          if (rule.selectorText && rule.selectorText.startsWith(".mdi-")) {
            const match = rule.selectorText.match(/\.mdi-([a-zA-Z0-9_-]+)/);
            if (match) mdiRules.push(match[1]);
          }
          if (rule.selectorText && rule.selectorText.startsWith(".dripicons-")) {
            const match = rule.selectorText.match(/\.dripicons-([a-zA-Z0-9_-]+)/);
            if (match) dripRules.push(match[1]);
          }
          // Font Awesome: .fa-xxx:before
          if (rule.selectorText && rule.selectorText.startsWith(".fa-") && rule.selectorText.endsWith(":before")) {
            const match = rule.selectorText.match(/\.fa-([a-zA-Z0-9_-]+):before/);
            if (match) faRules.push(match[1]);
          }
        }
      } catch (e) {
        // Ignore cross-origin errors
      }
    }
    setIconNames([...new Set(mdiRules)]);
    setDripiconNames([...new Set(dripRules)]);
    setFaNames([...new Set(faRules)]);
    // Liste des icônes react-icons/fa
    setFaReactNames(Object.keys(FaIcons));
  }, []);

  const filteredIcons = iconNames.filter(name =>
    name.toLowerCase().includes(filter.toLowerCase())
  );
  const filteredDripicons = dripiconNames.filter(name =>
    name.toLowerCase().includes(filter.toLowerCase())
  );
  const filteredFa = faNames.filter(name =>
    name.toLowerCase().includes(filter.toLowerCase())
  );
  const filteredFaReact = faReactNames.filter(name =>
    name.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <div className="page-content text-center">
      <h1 className="text-primary">Icons Library</h1>
      <input
        type="text"
        placeholder="Filtrer par nom..."
        value={filter}
        onChange={e => setFilter(e.target.value)}
        style={{ marginBottom: 24, marginTop: 20, padding: 8, width: 350 }}
      />
      <h3 className="text-secondary">Material Design Icons</h3>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "24px", marginTop: "10px" }}>
        {filteredIcons.map(name => (
          <div key={"mdi-"+name} style={{ width: 100, textAlign: "center" }}>
            <i className={`mdi mdi-${name}`} style={{ fontSize: 32 }} />
            <div style={{ fontSize: 12, marginTop: 8 }}>{`mdi-${name}`}</div>
          </div>
        ))}
      </div>
      <h3 className="text-secondary" style={{ marginTop: 32 }}>Dripicons</h3>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "24px", marginTop: "10px" }}>
        {filteredDripicons.map(name => (
          <div key={"dripicons-"+name} style={{ width: 100, textAlign: "center" }}>
            <i className={`dripicons dripicons-${name}`} style={{ fontSize: 32 }} />
            <div style={{ fontSize: 12, marginTop: 8 }}>{`dripicons-${name}`}</div>
          </div>
        ))}
      </div>
      <h3 className="text-secondary" style={{ marginTop: 32 }}>Font Awesome (CSS)</h3>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "24px", marginTop: "10px" }}>
        {filteredFa.map(name => (
          <div key={"fa-"+name} style={{ width: 100, textAlign: "center" }}>
            <i className={`fa fa-${name}`} style={{ fontSize: 32 }} />
            <div style={{ fontSize: 12, marginTop: 8 }}>{`fa-${name}`}</div>
          </div>
        ))}
      </div>
      <h3 className="text-secondary" style={{ marginTop: 32 }}>Font Awesome (react-icons)</h3>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "24px", marginTop: "10px" }}>
        {filteredFaReact.map(name => {
          const IconComponent = FaIcons[name];
          return IconComponent ? (
            <div key={name} style={{ width: 100, textAlign: "center" }}>
              <IconComponent style={{ fontSize: 32 }} />
              <div style={{ fontSize: 12, marginTop: 8 }}>{name}</div>
            </div>
          ) : null;
        })}
      </div>
    </div>
  );
}